import { FC, useEffect, useState } from 'react';
// @ts-ignore
import PrivacyPolicy from '@lds/privacy-policy';
import { useDetermineLocale } from '@/hooks/use-determine-locale';
import Cookies from 'js-cookie';
import { isPharmaprixBanner } from '@/utils';
import { environment } from 'Data/constants';

//lds style sheet
import '@lds/privacy-policy/dist/index.scss';

const FooterPrivacyPolicy: FC = () => {
  const locale = useDetermineLocale();

  const [isDocumentPresent, setIsDocumentPresent] = useState(false);
  useEffect(() => {
    return setIsDocumentPresent(true);
  }, []);

  const setPrivacyCookie = () => {
    const maxAge = 2592000; // one month in seconds
    const cookieParameter: Cookies.CookieAttributes = { expires: maxAge };

    const requiredDomain = isPharmaprixBanner() ? 'pharmaprix.ca' : 'shoppersdrugmart.ca';

    //TODO: use new util/auth fcn that will be merged
    if (process.env.NODE_ENV === environment.PRODUCTION) {
      cookieParameter.domain = requiredDomain;
    }
    Cookies.set('SDM_privacy', 'true', cookieParameter);
  };

  const closeHandler = () => {
    setPrivacyCookie();
  };

  const getPrivacyCookie = () => {
    const isCookieSet = Cookies.get('SDM_privacy');
    return !isCookieSet;
  };

  return isDocumentPresent ? (
    <PrivacyPolicy lang={locale} isShown={getPrivacyCookie()} onClose={() => closeHandler()} />
  ) : null;
};

export default FooterPrivacyPolicy;
